import type { PublicSubscriptionPlan } from "@/shared/services/publicPlansApi";

/** Static fallback when public API is unreachable (keeps page usable). */
export const FALLBACK_PUBLIC_PLANS: PublicSubscriptionPlan[] = [
    {
        code: "start",
        name: "Стартер",
        audienceLabel: "Для самозанятых (НПД), ремесленников и КФХ",
        badge: "НПД / ремесло / КФХ",
        featured: false,
        amount: 50,
        yearlyAmount: 450,
        currency: "BYN",
        maxProducts: 20,
        maxServices: 20,
        maxStaff: 3,
        maxLocations: 1,
        bullets: [
            "Telegram Mini App + веб-витрина + CRM в одном окне",
            "Запись на услуги, календарь, база клиентов",
            "Новости / рассылки, бонусы и промокоды",
            "До 20 товаров, 20 услуг, 3 сотрудника, 1 точка",
        ],
        excluded: ["Склад FIFO", "P&L / зарплаты", "СКУД", "HoReCa KDS", "Инвойсы"],
        ctaLabel: "Попробовать бесплатно",
        sortOrder: 10,
    },
    {
        code: "business",
        name: "Бизнес",
        audienceLabel: "Для салонов, барбершопов, розницы, услуг и островков в ТЦ",
        badge: "Хит продаж",
        featured: true,
        amount: 99,
        yearlyAmount: 900,
        currency: "BYN",
        maxProducts: 500,
        maxServices: 500,
        bullets: [
            "Всё из «Стартер» + склад FIFO и техкарты",
            "Кассы, P&L и расчёт зарплат",
            "Колесо фортуны, рефералка, сертификаты, рассылки",
            "До 500 товаров и 500 услуг",
        ],
        excluded: ["СКУД Access Control", "Booking 2.0 ресурсы", "HoReCa KDS"],
        ctaLabel: "Попробовать бесплатно",
        sortOrder: 20,
    },
    {
        code: "pro",
        name: "Про / СКУД",
        audienceLabel: "Для фитнес-клубов, залов, коворкингов, студий и кафе/ресторанов (1 объект)",
        badge: "Фитнес / HoReCa",
        featured: false,
        amount: 189,
        yearlyAmount: 1680,
        currency: "BYN",
        bullets: [
            "Всё из «Бизнес» + Access Control (QR/NFC)",
            "Booking 2.0: ресурсы и групповые занятия",
            "HoReCa: залы, столы, KDS, принтеры",
            "Инвойсы и акты",
        ],
        excluded: ["Мульти-точки холдинга"],
        ctaLabel: "Попробовать бесплатно",
        sortOrder: 30,
    },
    {
        code: "holding",
        name: "Холдинг",
        audienceLabel: "Для сетей фитнес-клубов, ресторанных групп и мульти-бизнесов (3–10 точек)",
        badge: "Сети",
        featured: false,
        amount: 349,
        yearlyAmount: 2988,
        currency: "BYN",
        maxLocations: 10,
        bullets: [
            "Всё из «Про» на объекты холдинга",
            "Фикс 349 BYN/мес (или −25% при оплате за год)",
            "Единый контур CRM и аналитики по сети",
            "От 3 до 10 точек в одном договоре",
        ],
        excluded: [],
        ctaLabel: "Обсудить сеть",
        sortOrder: 40,
    },
];
